module.exports = __webpack_public_path__ + "img/x-circle.eed5defd.png";